export const processNumberInput = (value: any) => {
  const cleanedValue = value
    .replace(/[^\d.]|(?<=\..*)\./g, '')
    .replace(/^(0+)(?![.,])\d/, '');
  return cleanedValue;
};
